import React, { useEffect, useState } from "react"
import { message, Modal, Spin } from "antd"
import "../../styles/Components/storeresubmissionmodal.css"
import { Store } from "../../Apis/storeApis"
import { useSelector } from "react-redux"
import { getUserCookies } from "../../utils/Cookies"
import { jwtDecode } from "jwt-decode"
import { translations } from "../../utils/Translation/staticTranslation"

const StoreResubmissionChat = ({
  RejectedId,
  isModalOpen,
  handleCancel,
  isPermanentlyRejected = false,
}) => {
  const user = useSelector((state) => state.user.user)
  const [comments, setComments] = useState([])
  const [newComment, setNewComment] = useState("")
  const [loading, setLoading] = useState(false)
  const highest_role =
    getUserCookies()?.token && jwtDecode(getUserCookies()?.token).highest_role

  const lang = localStorage.getItem("language") || "ar"
  const storePage = translations[lang]?.StorePage
  const { common_error_msg } = translations[lang]

  useEffect(() => {
    setLoading(true)
    const fetchComments = async (RejectedId) => {
      try {
        const response = await Store.getComments(RejectedId)
        if (response.status === 200) {
          // message.success("Store deleted successfully");
          setComments(response.data)
        }
      } catch (error) {
        message.error(common_error_msg?.failed_to_fetch_comments)
        console.error("Error Get Comments:", error)
      } finally {
        setLoading(false)
      }
    }
    if (isModalOpen) {
      fetchComments(RejectedId)
    }
  }, [RejectedId, isModalOpen])

  const createComment = async () => {
    const payload = {
      comment_text: newComment,
    }
    try {
      const response = await Store.createComment(payload, RejectedId)
      if (response.status === 201) {
        setComments([...comments, response.data])
        setNewComment("") // Clear input
        message.success(storePage?.comments_modal?.comment_added_successfully)
      }
    } catch (error) {
      message.error(common_error_msg?.failed_to_create_comments)
      console.error("Error Get Comments:", error)
    }
  }

  return (
    <Modal
      title={storePage?.comments_modal?.store_resubmission_comments}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
    >
      {/* Comments */}

      <div className="" style={{ height: "200px", overflowY: "auto" }}>
        {loading ? (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Spin size="large" />
          </div>
        ) : comments?.length > 0 ? (
          comments.map((comment, index) => (
            <div key={comment.id + index}>
              <div className="d-flex mb-32">
                <div className="mr-10">
                  <img
                    src={`${
                      comment?.profile_picture_url
                        ? comment?.profile_picture_url
                        : "/Navbar/personicon.svg"
                    }`}
                    width={28}
                    height={28}
                    style={{ borderRadius: "100%" }}
                    alt=""
                  />
                </div>
                <div>
                  <div className="d-flex align-items-center">
                    <p className="mb-0 text-141414 font-600 mr-8">
                      {comment.user_name}
                    </p>
                    <div className="dot mr-8"></div>
                    <p className="mb-0 text-7A7A7A text-13 font-400 mr-8">
                      {comment.time}
                    </p>
                  </div>
                  <p className="mb-0 text-141414 text-13 font-400">
                    {comment.comment_text}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            {storePage?.comments_modal?.no_comments}
          </div>
        )}
      </div>

      {/* Permanently rejected requests are closed: comments are read-only. */}
      {!isPermanentlyRejected &&
        (user?.role === "OWNER" ||
          highest_role === "ADMIN" ||
          highest_role === "SUPERADMIN") && (
          <div className="comment-container">
            <label
              htmlFor="comment"
              className="text-14 font-400 text-141414 mb-14"
            >
              {storePage?.comments_modal?.comment}
            </label>
            <div className="input-wrapper">
              <div>
                <textarea
                  onChange={(e) => setNewComment(e.target.value)}
                  value={newComment}
                  rows="3"
                  id="comment"
                  placeholder={storePage?.comments_modal?.comment_placeholder}
                ></textarea>
              </div>
              <div className="enter-comment-button">
                <div className="submit-btn" onClick={createComment}>
                  <img src="/Storecomments/tick.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        )}
    </Modal>
  )
}

export default StoreResubmissionChat
